import { AxiosError } from 'axios';
import { t } from 'i18next';
import { useCallback, useState } from 'react';
import { useTheme } from 'styled-components';

import Modal from '../../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../../components/Notification';
import HttpStatus from '../../../../../../enums/httpStatus';
import { visitRoutineAPI } from '../../../../../../services/requests';
import { SellerVisitRoutine } from '../../../../../../types';

type Props = {
  selecteditem: SellerVisitRoutine;
  closeModal: () => void;
  reqCallback: () => void;
};

const ModalDeleteItem = ({ selecteditem, closeModal, reqCallback }: Props) => {
  const [waitingReq, setWaitingReq] = useState(false);

  const theme = useTheme();

  const reqDelete = useCallback(async () => {
    setWaitingReq(true);

    const source = visitRoutineAPI.axios.CancelToken.source();

    try {
      const res = await visitRoutineAPI.delete(selecteditem.id);

      if (res.status === HttpStatus.OK) {
        frontendNotification({
          message: t('successfullyDeleted'),
          type: 'success',
        });

        reqCallback();
        setWaitingReq(false);
        closeModal();
      } else {
        throw res;
      }
    } catch (err) {
      if (!visitRoutineAPI.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
    }

    setWaitingReq(false);
    return () => {
      source.cancel('Component got unmounted');
    };
  }, []);

  return (
    <Modal
      title={`${t('delete')}`}
      action={() => reqDelete()}
      showModal
      closeModal={closeModal}
      cancelButton={closeModal}
      actionNameBtn={t('delete')}
      isLoading={waitingReq}
      style={{ color: theme.colors.onBackground }}
    >
      <div style={{ padding: '1rem' }}>
        <h3>{`${t('deleteSure') as string}?`}</h3>
        <p>
          <b>{t('id') as string}: </b>
          {selecteditem.id}
        </p>
        <p>
          <b>{t('weekDay') as string}: </b>
          {selecteditem.DiaSemana}
        </p>
        <p>
          <b>{t('routineStartDate') as string}: </b>
          {selecteditem.start_date}
        </p>
        <p>
          <b>{t('sellerCode') as string}: </b>
          {selecteditem.CodigoVendedor}
        </p>
        <p>
          <b>{t('customerCode') as string}: </b>
          {selecteditem.customer?.CodigoCliente}
        </p>
        <p>
          <b>{t('customerName') as string}: </b>
          {selecteditem.customer?.RazaoSocial}
        </p>
        <p>
          <b>{t('note') as string}: </b>
          {selecteditem.Obs}
        </p>
      </div>
    </Modal>
  );
};

export default ModalDeleteItem;
